import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBase";
import { IDocumentType } from "Models/DocumentType";

export const documentTypeApi = createApi({
  reducerPath: "documentTypeApi",
  baseQuery: customFetchBase,
  tagTypes: ["DocumentType"],
  endpoints: (builder) => ({
    getAllDocumentTypes: builder.query<IDocumentType[],void>({
        query() {
            return {
              url: "documentTypes",
              method: "GET",
              credentials: "include",
            };
        },
      transformResponse: (results: {data:IDocumentType[]}) =>
        results.data,
      providesTags: () => ["DocumentType"],
    }),
    getAPieceOfDocumentType: builder.query<IDocumentType, string>({
      query(documentTypeId) {
        return {
          url: "documentTypes/" + documentTypeId,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["DocumentType"],
      transformResponse: (result: { data: IDocumentType }) => {
        return result.data;
      },
    }),
  }),
});

export const {
  useGetAllDocumentTypesQuery,
  useGetAPieceOfDocumentTypeQuery,
} = documentTypeApi;
